import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as summaryReportAction from "../../../store/summary-report/action";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Table,
} from "reactstrap";
import {
  DELETE_RP_BALANCE_EAST,
  DELETE_RP_BALANCE_EVENT,
  DELETE_RP_BALANCE_TOTAL,
  DELETE_RP_BALANCE_WEST,
  GET_RP_BALANCE,
  GET_RP_BALANCE_EAST,
  GET_RP_BALANCE_EVENT,
  GET_RP_BALANCE_TOTAL,
  GET_RP_BALANCE_WEST,
  SAVE_LIST_RP_BALANCE_EAST,
  SAVE_LIST_RP_BALANCE_EVENT,
  SAVE_LIST_RP_BALANCE_TOTAL,
  SAVE_LIST_RP_BALANCE_WEST,
  SAVE_RP_BALANCE_EAST,
  SAVE_RP_BALANCE_EVENT,
  SAVE_RP_BALANCE_TOTAL,
  SAVE_RP_BALANCE_WEST,
} from "helpers/url_api_constant";
import React, { useCallback, useEffect, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import Balancing from "./Balacing";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import LineGraphEast from "./LineGraphEast";
import LineGraphTotal from "./LineGraphTotal";
import LineGraphWest from "./LineGraphWest";
import Offshore from "../SectionBalancing/Offshore/Offshore";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";

function SectionBalancing(props) {
  // console.log(props);
  const dispatch = useDispatch();
  const permission = getPermission();
  // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
  //     "YYYY-MM-DD"));
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [dialogTotal, setDialogTotal] = useState(false);
  const [dialogEast, setDialogEast] = useState(false);
  const [dialogWest, setDialogWest] = useState(false);
  const [dialogShipper, setDialogShipper] = useState(false);

  const [listTotalData, setListTotalData] = useState([]);
  const [listEastData, setListEastData] = useState([]);
  const [listWestData, setListWestData] = useState([]);


  const [dataGraphBalacing, setDataGraphBalacing] = useState([]);
  const [shipperList, setShipperList] = useState([]);

  const [minMaxOnshore, setMinMaxOnshore] = useState({
    total: [],
    east: [],
    west: [],
  });

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

  const SelectDateStartTotal = (cellContent, row) => {
    return (
      <div>
        <Flatpickr
          // value={this.state.defaultDate}
          className="form-control d-block"
          placeholder="Select Date"
          options={{
            altInput: true,
            altFormat: "d/m/Y",
            // altFormat: "F Y",
            dateFormat: "d/m/Y",
            // minDate: new Date(),
            // maxDate: new Date(),
          }}
          onChange={value => {
            // console.log(value);
            setListTotalData(prevent => {
              return prevent.map(obj => {
                if (obj.ROW == row.ROW) {
                  return {
                    ...obj,
                    START_DATE: moment(value[0]).format("YYYY-MM-DD"),
                    TEMP_START_DATE: value[0],
                  };
                }
                if (obj.ROW == row.ROW - 1) {
                  // console.log(obj);
                  return {
                    ...obj,
                    END_DATE: moment(value[0])
                      .add("days", -1)
                      .format("YYYY-MM-DD"),
                  };
                }

                return { ...obj };
              })
            }
            );
          }}
          value={row.TEMP_START_DATE}
        />
      </div>
    );
  };

  const SelectDateEndTotal = (cellContent, row, rowIndex) => {
    return (
      <div>
        <span>
          {row.END_DATE ? moment(row.END_DATE).format("DD/MM/YYYY") : ""}
        </span>
      </div>
    );
  };

  const SelectDateStartEast = (cellContent, row) => {
    return (
      <div>
        <Flatpickr
          // value={this.state.defaultDate}
          className="form-control d-block"
          placeholder="Select Date"
          options={{
            altInput: true,
            altFormat: "d/m/Y",
            // altFormat: "F Y",
            dateFormat: "d/m/Y",
            // minDate: new Date(),
            // maxDate: new Date(),
          }}
          onChange={value => {
            // console.log(value);
            setListEastData(prevent => {
              return prevent.map(obj => {
                if (obj.ROW == row.ROW) {
                  return {
                    ...obj,
                    START_DATE: moment(value[0]).format("YYYY-MM-DD"),
                    TEMP_START_DATE: value[0],
                  };
                }
                if (obj.ROW == row.ROW - 1) {
                  return {
                    ...obj,
                    END_DATE: moment(value[0])
                      .add("days", -1)
                      .format("YYYY-MM-DD"),
                  };
                }

                return { ...obj };
              })
            }
            );
          }}
          value={row.TEMP_START_DATE}
        />
      </div>
    );
  };

  const SelectDateEndEast = (cellContent, row, rowIndex) => {
    return (
      <div>
        <span>
          {row.END_DATE ? moment(row.END_DATE).format("DD/MM/YYYY") : ""}
        </span>
      </div>
    );
  };

  const SelectDateStartWest = (cellContent, row) => {
    return (
      <div>
        <Flatpickr
          // value={this.state.defaultDate}
          className="form-control d-block"
          placeholder="Select Date"
          options={{
            altInput: true,
            altFormat: "d/m/Y",
            // altFormat: "F Y",
            dateFormat: "d/m/Y",
            // minDate: new Date(),
            // maxDate: new Date(),
          }}
          onChange={value => {
            // console.log(value);
            setListWestData(prevent => {
              return prevent.map(obj => {
                if (obj.ROW == row.ROW) {
                  return {
                    ...obj,
                    START_DATE: moment(value[0]).format("YYYY-MM-DD"),
                    TEMP_START_DATE: value[0],
                  };
                }
                if (obj.ROW == row.ROW - 1) {
                  return {
                    ...obj,
                    END_DATE: moment(value[0])
                      .add("days", -1)
                      .format("YYYY-MM-DD"),
                  };
                }

                return { ...obj };
              })
            }
            );
          }}
          value={row.TEMP_START_DATE}
        />
      </div>
    );
  };

  const SelectDateEndWest = (cellContent, row, rowIndex) => {
    return (
      <div>
        <span>
          {row.END_DATE ? moment(row.END_DATE).format("DD/MM/YYYY") : ""}
        </span>
      </div>
    );
  };

  const ButtonTotal = (cellContent, row) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {row.END_DATE != null && row.END_DATE != "" && (
          <>
            <OverButton
              onClick={() => {
                onTotalDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };

  const ButtonEast = (cellContent, row) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {row.END_DATE != null && row.END_DATE != "" && (
          <>
            <OverButton
              onClick={() => {
                onEastDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };

  const ButtonWest = (cellContent, row) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {row.END_DATE != null && row.END_DATE != "" && (
          <>
            <OverButton
              onClick={() => {
                onWestDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };

  const columnTotal = [
    {
      dataField: "dummy",
      formatter: CountIndexRow,
      text: "No.",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
      type: "number",
    },
    {
      dataField: "BALANCE_MIN",
      text: "Min",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "BALANCE_MAX",
      text: "Max",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      // formatter: SelectEntryZone,
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    // {
    //   dataField: "BALANCE_AVG",
    //   text: "Average",
    //   headerAlign: "center",
    //   sort: false,
    //   editable: true,
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "14px",
    //   },
    //   style: {
    //     width: "15%",
    //   },
    //   validator: (newValue, row, column, done) => {
    //     setTimeout(() => {
    //       if (isNaN(newValue)) {
    //         return done({
    //           valid: false,
    //           message: "Should be numeric",
    //         });
    //       }
    //       return done();
    //     }, 0);
    //     return {
    //       async: true,
    //     };
    //   },
    // },
    {
      dataField: "START_DATE",
      text: "Start",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateStartTotal,
    },
    {
      dataField: "END_DATE",
      text: "End",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateEndTotal,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      editable: false,
      sort: false,
      formatter: ButtonTotal,
      headerAlign: "center",
      align: "left",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
    },
  ];

  const columnEast = [
    {
      dataField: "dummy",
      formatter: CountIndexRow,
      text: "No.",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
      type: "number",
    },
    {
      dataField: "BALANCE_MIN",
      text: "Min",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "BALANCE_MAX",
      text: "Max",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      // formatter: SelectEntryZone,
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    // {
    //   dataField: "BALANCE_AVG",
    //   text: "Average",
    //   headerAlign: "center",
    //   sort: false,
    //   editable: true,
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "14px",
    //   },
    //   style: {
    //     width: "15%",
    //   },
    //   // formatter: SelectEntryZone,
    //   validator: (newValue, row, column, done) => {
    //     setTimeout(() => {
    //       if (isNaN(newValue)) {
    //         return done({
    //           valid: false,
    //           message: "Should be numeric",
    //         });
    //       }
    //       return done();
    //     }, 0);
    //     return {
    //       async: true,
    //     };
    //   },
    // },
    {
      dataField: "START_DATE",
      text: "Start",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateStartEast,
    },
    {
      dataField: "END_DATE",
      text: "End",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateEndEast,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      editable: false,
      sort: false,
      formatter: ButtonEast,
      headerAlign: "center",
      align: "left",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
    },
  ];

  const columnWest = [
    {
      dataField: "dummy",
      formatter: CountIndexRow,
      text: "No.",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
      type: "number",
    },
    {
      dataField: "BALANCE_MIN",
      text: "Min",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "BALANCE_MAX",
      text: "Max",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      // formatter: SelectEntryZone,
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    // {
    //   dataField: "BALANCE_AVG",
    //   text: "Average",
    //   headerAlign: "center",
    //   sort: false,
    //   editable: true,
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "14px",
    //   },
    //   style: {
    //     width: "15%",
    //   },
    //   // formatter: SelectEntryZone,
    //   validator: (newValue, row, column, done) => {
    //     setTimeout(() => {
    //       if (isNaN(newValue)) {
    //         return done({
    //           valid: false,
    //           message: "Should be numeric",
    //         });
    //       }
    //       return done();
    //     }, 0);
    //     return {
    //       async: true,
    //     };
    //   },
    // },
    {
      dataField: "START_DATE",
      text: "Start",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateStartWest,
    },
    {
      dataField: "END_DATE",
      text: "End",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "14px",
      },
      style: {
        width: "15%",
      },
      formatter: SelectDateEndWest,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      editable: false,
      sort: false,
      formatter: ButtonWest,
      headerAlign: "center",
      align: "left",
      headerStyle: {
        width: "5%",
        fontSize: "14px",
      },
      style: {
        width: "5%",
      },
    },
  ];

  const defaultTotalSortColumn = [
    {
      dataField: "CREATE_DATE",
      order: "asc", // or desc
    },
  ];

  const defaultEastSortColumn = [
    {
      dataField: "CREATE_DATE",
      order: "asc", // or desc
    },
  ];

  const defaultWestSortColumn = [
    {
      dataField: "CREATE_DATE",
      order: "asc", // or desc
    },
  ];

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.CREATE_DATE < b.CREATE_DATE) {
      return -1;
    }
    if (a.CREATE_DATE > b.CREATE_DATE) {
      return 1;
    }
    return 0;
  };

  const openDialogTotal = async () => {
    setDialogTotal(true);
    reLoadDataTotal();
  };
  const reLoadDataTotal = async () => {
    setListTotalData([]);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_RP_BALANCE_TOTAL, {});
      // console.log(res);
      setListTotalData(
        res.data.rpBalancingTotalList.sort(compare).map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          START_DATE: moment(obj.START_DATE).format("YYYY-MM-DD"),
          TEMP_START_DATE: moment(obj.START_DATE).toDate(),
          END_DATE: obj.END_DATE ? obj.END_DATE : "",
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // setListTotalData([]);
  };

  const openDialogEast = async () => {
    setDialogEast(true);
    reLoadDataEast();
  };

  const reLoadDataEast = async () => {
    setListEastData([]);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_RP_BALANCE_EAST, {});
      // console.log(res);
      setListEastData(
        res.data.rpBalancingEastList.sort(compare).map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          START_DATE: moment(obj.START_DATE).format("YYYY-MM-DD"),
          TEMP_START_DATE: moment(obj.START_DATE).toDate(),
          END_DATE: obj.END_DATE ? obj.END_DATE : "",
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // setListEastData([]);
  };

  const openDialogWest = async () => {
    setDialogWest(true);
    reLoadDataWest();
  };

  const reLoadDataWest = async () => {
    setListWestData([]);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_RP_BALANCE_WEST, {});
      // console.log(res);
      setListWestData(
        res.data.rpBalancingWestList.sort(compare).map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          START_DATE: moment(obj.START_DATE).format("YYYY-MM-DD"),
          TEMP_START_DATE: moment(obj.START_DATE).toDate(),
          END_DATE: obj.END_DATE ? obj.END_DATE : "",
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // setListWestData([]);
  };

  useEffect(() => fetchDataOnshoreBalancing(), [props.summaryReportPid]);


  const fetchDataOnshoreBalancing = async (fromManageGraph = false) => {
    dispatch(loadingAction.showLoading());
    try {
      let [
        onshoreBalacing,
        graphBalacing,
        minMaxTotal,
        minMaxEest,
        minMaxWest,
      ] = await Promise.all([
        post(GET_RP_BALANCE, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
        post(GET_RP_BALANCE, {
          REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
        }),
        post(GET_RP_BALANCE_TOTAL, {}),
        post(GET_RP_BALANCE_EAST, {}),
        post(GET_RP_BALANCE_WEST, {}),
      ]);
      onshoreBalacing = onshoreBalacing.data.rpBalancingList.sort((a, b) =>
        a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
          ? 1
          : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
            ? -1
            : 0
      );
      let shipper = [
        ...new Set(onshoreBalacing.map(item => item.BALANCECOLUMN_NAME)),
      ];
      let tempColor = ["#FF7F37", "#62C6FF", "#FFF577", "#599335", "#DB4F4F", "#7B7AB4", "#22EED1", "#874820", "#FFF810", "#909090"];


      shipper = shipper.map((row, index) => {
        let PID = onshoreBalacing.find(
          obj => obj.BALANCECOLUMN_NAME == row
        )?.BALANCECOLUMN_PID;
        let temp = { SHIPPER_NAME: row, PID, garphColor: tempColor[index] };
        return temp;
      });
      
     

      if (graphBalacing.resultCode == 200) {
        graphBalacing = [...graphBalacing.data.rpBalancingList,...onshoreBalacing.map((row)=>({...row,REPORT_DATE:props.date}))];
      } else {
        graphBalacing = [];
      }

      // console.log(graphBalacing);
      // console.log(minMaxTotal.data.rpBalancingTotalList)
      if (!fromManageGraph) {
        setDataGraphBalacing(graphBalacing);
        setShipperList(shipper);
      }
      setMinMaxOnshore({
        ...minMaxOnshore,
        total: minMaxTotal.data.rpBalancingTotalList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        })),
        east: minMaxEest.data.rpBalancingEastList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        })),
        west: minMaxWest.data.rpBalancingWestList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        })),
      });
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const handleTotalAddColumn = () => {
    setListTotalData(prevent => [
      ...prevent,
      {
        ROW: listTotalData.length + 1,
        PID: "",
        // TOTAL_ORDER: listTotalData.length + 1,
        BALANCE_MIN: 0,
        BALANCE_MAX: 0,
        BALANCE_AVG: 0,
        START_DATE: "",
        END_DATE: "",
        TEMP_START_DATE: "",
      },
    ]);
  };

  const handleSaveTotal = async () => {
    dispatch(loadingAction.showLoading());
    try {
      if (
        !listTotalData.some(
          row => row.BALANCE_MIN == "" || row.BALANCE_MAX == ""
          // row.START_DATE == ""
        )
      ) {
        let data = [...listTotalData];
        let res = await post(SAVE_LIST_RP_BALANCE_TOTAL, data);
        // console.log(res);
        if (res.resultCode == 200) {
          fetchDataOnshoreBalancing(true);
          setDialogTotal(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const handleEastAddColumn = () => {
    setListEastData(prevent => [
      ...prevent,
      {
        ROW: listEastData.length + 1,
        PID: "",
        BALANCE_MIN: 0,
        BALANCE_MAX: 0,
        BALANCE_AVG: 0,
        START_DATE: "",
        END_DATE: "",
        TEMP_START_DATE: "",
      },
    ]);
  };

  const handleSaveEast = async () => {
    dispatch(loadingAction.showLoading());
    try {
      if (
        !listEastData.some(
          row => row.BALANCE_MIN == "" || row.BALANCE_MAX == ""
          // row.START_DATE == ""
        )
      ) {
        let data = [...listEastData];
        let res = await post(SAVE_LIST_RP_BALANCE_EAST, data);
        // console.log(res);
        if (res.resultCode == 200) {
          fetchDataOnshoreBalancing(true);
          setDialogEast(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const handleWestAddColumn = () => {
    setListWestData(prevent => [
      ...prevent,
      {
        ROW: listWestData.length + 1,
        PID: "",
        BALANCE_MIN: 0,
        BALANCE_MAX: 0,
        BALANCE_AVG: 0,
        START_DATE: "",
        END_DATE: "",
        TEMP_START_DATE: "",
      },
    ]);
  };

  const handleSaveWest = async () => {
    dispatch(loadingAction.showLoading());
    try {
      if (
        !listWestData.some(
          row => row.BALANCE_MIN == "" || row.BALANCE_MAX == ""

          // row.START_DATE == ""
        )
      ) {
        let data = [...listWestData];
        let res = await post(SAVE_LIST_RP_BALANCE_WEST, data);
        // console.log(res);
        if (res.resultCode == 200) {
          fetchDataOnshoreBalancing(true);
          setDialogWest(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const onTotalDelete = row => {
    dispatch(
      confirmAction.showConfirm("Do you want to delete ?", () => {
        deleteTotal(row);
      })
    );
  };

  const deleteTotal = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(DELETE_RP_BALANCE_TOTAL, row);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Delete Success."));
        fetchDataOnshoreBalancing(true);
        reLoadDataTotal();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
      dispatch(loadingAction.hideLoading());
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
      dispatch(loadingAction.hideLoading());
    }
  };

  const onEastDelete = row => {
    dispatch(
      confirmAction.showConfirm("Do you want to delete ?", () => {
        deleteEast(row);
      })
    );
  };

  const deleteEast = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(DELETE_RP_BALANCE_EAST, row);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Delete Success."));
        fetchDataOnshoreBalancing(true);
        reLoadDataEast();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
      dispatch(loadingAction.hideLoading());
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
      dispatch(loadingAction.hideLoading());
    }
  };

  const onWestDelete = row => {
    dispatch(
      confirmAction.showConfirm("Do you want to delete ?", () => {
        deleteWest(row);
      })
    );
  };

  const deleteWest = async row => {
    dispatch(loadingAction.showLoading());
    try {
      // console.log(row);
      let res = await post(DELETE_RP_BALANCE_WEST, row);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Delete Success."));
        fetchDataOnshoreBalancing(true);
        reLoadDataWest();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
      dispatch(loadingAction.hideLoading());
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
      dispatch(loadingAction.hideLoading());
    }
  };

  return (
    <div>
      <Row>
        <Col sm="12">
          <Card  className="mb-1" style={{ backgroundColor: "#001fff1f" }}>
            <CardBody>
              <Row className="mt-0">
                <Col sm="12">
                  <h5
                    className="mb-0 sm-0 font-size-18"
                    style={{ color: "#2FA3FF" }}
                  >
                    Balancing
                  </h5>
                </Col>
              </Row>

              <Row className="mt-2">
                <hr style={{ color: "#2FA3FF" }} />
              </Row>

              <Row className="mt-0">
                {/* <Col sm="3" className="d-flex align-items-center justify-content-start">
                                    <div className="d-grid gap-2 d-md-block">
                                        <Button
                                            // onClick={() => saveData()}
                                            color="primary"
                                            className="btn w-md ms-0"
                                        // disabled={readonly == true}
                                        >
                                            <i className="bx bx-columns"> </i> &nbsp;&nbsp; Manage Shipper &nbsp;&nbsp;
                                        </Button>
                                    </div>
                                </Col> */}
                <Col
                  sm="6"
                  className="d-flex align-items-center justify-content-end"
                >
                  <h5
                    className="mb-0 sm-0 font-size-15"
                    style={{ color: "#2FA3FF" }}
                  >
                    {" "}
                    Unit : BBTU
                  </h5>
                </Col>
              </Row>

              <Row className="mt-0">
                <Balancing
                  date={props.date}
                  summaryReportPid={props.summaryReportPid}
                  shipperList={shipperList}
                />
                <Col lg={6}>
                  <div>
                    <CardTitle
                      className="mb-0 mt-0 me-0"
                      style={{ color: "#2FA3FF", fontSize: "25px" }}
                    >
                      Onshore Balancing ( Total )
                    </CardTitle>

                    {permission.mMIM && (
                      <Button
                        onClick={() => openDialogTotal()}
                        color="primary"
                        className="btn w-md ms-0 mt-0 mb-0"
                      // disabled={readonly == true}
                      >
                        <i className="fas fa-chart-line"> </i> &nbsp;&nbsp;&nbsp;
                        Manage Criteria Total &nbsp;&nbsp;&nbsp;
                      </Button>
                    )}

                    <LineGraphTotal
                      shipperList={shipperList}
                      data={dataGraphBalacing.filter(
                        row => row.BALANCING_ZONE.toLowerCase() == "total"
                      )}
                      date={props.date}
                      minMax={minMaxOnshore.total}
                      summaryReportPid={props.summaryReportPid}
                    />
                  </div>
                  <div>
                    <CardTitle
                      className="mb-0 mt-0"
                      style={{ color: "#2FA3FF", fontSize: "25px" }}
                    >
                      Onshore Balancing ( East )
                    </CardTitle>

                    {permission.mMIM && (
                      <Button
                        onClick={() => openDialogEast()}
                        color="primary"
                        className="btn w-md ms-0 mt-0 mb-0"
                      // disabled={readonly == true}
                      >
                        <i className="fas fa-chart-line"> </i> &nbsp;&nbsp;&nbsp;
                        Manage Criteria East &nbsp;&nbsp;&nbsp;
                      </Button>
                    )}

                    <LineGraphTotal
                      shipperList={shipperList}
                      data={dataGraphBalacing.filter(
                        row => row.BALANCING_ZONE.toLowerCase() == "east"
                      )}
                      date={props.date}
                      minMax={minMaxOnshore.east}
                      summaryReportPid={props.summaryReportPid}
                    />
                    {/* <LineGraphEast /> */}
                  </div>
                  <div>
                    <CardTitle
                      className="mb-0 mt-0"
                      style={{ color: "#2FA3FF", fontSize: "25px" }}
                    >
                      Onshore Balancing ( West )
                    </CardTitle>

                    {permission.mMIM && (
                      <Button
                        onClick={() => openDialogWest()}
                        color="primary"
                        className="btn w-md ms-0 mt-0 mb-0"
                      // disabled={readonly == true}
                      >
                        <i className="fas fa-chart-line"> </i> &nbsp;&nbsp;&nbsp;
                        Manage Criteria West &nbsp;&nbsp;&nbsp;
                      </Button>
                    )}

                    <LineGraphTotal
                      shipperList={shipperList}
                      data={dataGraphBalacing.filter(
                        row => row.BALANCING_ZONE.toLowerCase() == "west"
                      )}
                      date={props.date}
                      minMax={minMaxOnshore.west}
                      summaryReportPid={props.summaryReportPid}
                    />
                    {/* <LineGraphWest /> */}
                  </div>
                </Col>
              </Row>

              <Offshore
                date={props.date}
                summaryReportPid={props.summaryReportPid}
              ></Offshore>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* 2FA3FF */}

      {/*start : DialogTotal */}
      <Modal size="xl" isOpen={dialogTotal} backdrop={"static"}>
        <div className="modal-header" style={{ backgroundColor: "#001fff1f" }}>
          <h5 className="modal-title mt-0">Criteria Total</h5>
        </div>
        <div className="modal-body" style={{ backgroundColor: "#001fff1f" }}>
          <CardBody>
            <BootstrapTable
              id="dialog-total-table"
              keyField="ROW"
              data={listTotalData}
              columns={columnTotal}
              rowStyle={rowStyleFontWhite}
              wrapperClasses="table-on-scroll"
              headerClasses="header-style"
              defaultSorted={defaultTotalSortColumn}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  // console.log(columnDataList);
                },
              })}
            />

            <div className="text-center mt-2">
              {permission.eSRT && (
                <>
                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                    onClick={() => handleTotalAddColumn()}
                  >
                    <i className="bx bx-plus"></i> Add
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => handleSaveTotal()}
                  >
                    <i className="bx bx-save"></i> Save
                  </button>
                </>
              )}
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => setDialogTotal(false)}
              >
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </CardBody>
        </div>
      </Modal>
      {/*end : DialogTotal */}

      {/*start : DialogEast */}
      <Modal size="xl" isOpen={dialogEast} backdrop={"static"}>
        <div className="modal-header" style={{ backgroundColor: "#001fff1f" }}>
          <h5 className="modal-title mt-0">Criteria East</h5>
        </div>
        <div className="modal-body" style={{ backgroundColor: "#001fff1f" }}>
          <CardBody>
            <BootstrapTable
              id="dialog-west-table"
              keyField="ROW"
              data={listEastData}
              columns={columnEast}
              rowStyle={rowStyleFontWhite}
              wrapperClasses="table-on-scroll"
              headerClasses="header-style"
              defaultSorted={defaultEastSortColumn}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  // console.log(columnDataList);
                },
              })}
            />
            <div className="text-center mt-2">
              {permission.eSRT && (
                <>
                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                    onClick={() => handleEastAddColumn()}
                  >
                    <i className="bx bx-plus"></i> Add
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => handleSaveEast()}
                  >
                    <i className="bx bx-save"></i> Save
                  </button>
                </>
              )}
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => setDialogEast(false)}
              >
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </CardBody>
        </div>
      </Modal>
      {/*end : DialogEast */}

      {/*start : DialogWest */}
      <Modal size="xl" isOpen={dialogWest} backdrop={"static"}>
        <div className="modal-header" style={{ backgroundColor: "#001fff1f" }}>
          <h5 className="modal-title mt-0">Criteria West</h5>
        </div>
        <div className="modal-body" style={{ backgroundColor: "#001fff1f" }}>
          <CardBody>
            <BootstrapTable
              id="dialog-west-table"
              keyField="ROW"
              data={listWestData}
              columns={columnWest}
              rowStyle={rowStyleFontWhite}
              wrapperClasses="table-on-scroll"
              headerClasses="header-style"
              defaultSorted={defaultWestSortColumn}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  // console.log(columnDataList);
                },
              })}
            />
            <div className="text-center mt-2">
              {permission.eSRT && (
                <>
                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                    onClick={() => handleWestAddColumn()}
                  >
                    <i className="bx bx-plus"></i> Add
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => handleSaveWest()}
                  >
                    <i className="bx bx-save"></i> Save
                  </button>
                </>
              )}
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => setDialogWest(false)}
              >
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </CardBody>
        </div>
      </Modal>
      {/*end : DialogWest */}

      {/*start : DialogManageShipper */}
      <Modal size="xl" isOpen={dialogShipper} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Shipper Balancing</h5>
          {/* <button
                        type="button"
                        onClick={() => {
                            props.hide()
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> */}
        </div>
        <div className="modal-body">
          {/* <BootstrapTable
                        // id="shipper-balancing-table"
                        // wrapperClasses="table-on-scroll"
                        keyField="ROW"
                        data={shipperManageList}
                        columns={shipperManage}
                        rowStyle={rowStyleFontWhite}
                        headerClasses="header-style"
                        defaultSorted={defaultSortShipperManage}
                        cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (oldValue, newValue, row, shipper) => {
                                // console.log(shipperDataList);
                            },
                        })}
                    /> */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
            // onClick={() => handleAddShipper()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
            // onClick={() => handleSaveShipper()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
            // onClick={() => props.hide()}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
      {/*end : DialogManageShipper */}

      {/* comfirmDialog */}
      {/* <ConfirmDialog
                isOpen={showConfirm}
                hide={toggleConfirm}
                message={messageConfirm}
                onConfirm={deleteTotal}
            /> */}
    </div>
  );
}

SectionBalancing.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionBalancing;
